import { exportExcel } from "@api/stores/customerReports/exportExcel/api";
import { exportPDF } from "@api/stores/customerReports/exportPDF/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  ICustomerReportsGetAllParams,
  ICustomerReportsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICustomerReportsResponse>>,
  IPathBaseParam,
  IPaginationParams & ICustomerReportsGetAllParams
>("stores.customerReports");

export const customerReports = {
  ...getAllApis,
  exportPDF,
  exportExcel,
};
